import { PosterBrand, PosterDesign } from '@/types/activation/poster';

/** A4 portrait at 96dpi — matches the lookbook's rasterization size. */
export const POSTER_PAGE_W = 794;
export const POSTER_PAGE_H = 1123;

interface PosterPageFrameProps {
  brand: PosterBrand;
  design: PosterDesign;
}

/**
 * One full A4 poster page — the design itself, edge-to-edge. Unlike the
 * lookbook's page frame, there's no caption/chrome added here: this render
 * IS the print output, so nothing gets burned onto the page that shouldn't
 * end up on a wall.
 */
export const PosterPageFrame = ({ brand, design }: PosterPageFrameProps) => {
  const { Component } = design;
  return (
    <div
      style={{
        width: POSTER_PAGE_W,
        height: POSTER_PAGE_H,
        overflow: 'hidden',
        fontFamily: 'Poppins, system-ui, sans-serif',
      }}
    >
      <Component brand={brand} />
    </div>
  );
};
